"use client";

import React, { useRef, useState, useEffect } from "react";
import { motion, useInView } from "framer-motion";
import Swal from "sweetalert2";
import { IoMdMail } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";

const Contact = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { threshold: 0.3 });
  const [animateKey, setAnimateKey] = useState(0);

  useEffect(() => {
    if (isInView) {
      setAnimateKey((prev) => prev + 1);
    }
  }, [isInView]);

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("access_key", "");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      Swal.fire({
        title: "Message Sent!",
        text: "We&apos;ll get back to you soon",
        icon: "success",
        confirmButtonColor: "#6366f1",
        customClass: { popup: "rounded-lg" },
      });
      event.target.reset();
    }
  };

  return (
    <section id="contact" ref={sectionRef} className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 ">
        <motion.div
          key={`title-${animateKey}`}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10"
        >
          <motion.p
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            className="text-black font-bold uppercase tracking-wide mb-2"
          >
            Let&apos;s Connect
          </motion.p>
          <h2 className="text-5xl font-extrabold text-black mb-4 font-bebas">
            Contact <span className="text-black">Us</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Have a question or want to work together? Fill out the form below
            and we&apos;ll get back to you within 24 hours.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          <motion.form
            key={`form-${animateKey}`}
            onSubmit={onSubmit}
            className="bg-white p-6 rounded-xl shadow-md"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Your Name</label>
                <input
                  type="text"
                  name="name"
                  className="w-full px-4 py-3 rounded-lg bg-gray-100 border border-gray-300 focus:outline-none focus:ring-2 text-black"
                  placeholder="Sulaiman"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 ">Email Address</label>
                <input
                  type="email"
                  name="email"
                  className="w-full px-4 py-3 rounded-lg bg-gray-100 border border-gray-300 focus:outline-none focus:ring-2 text-black"
                  placeholder="name@example.com"
                  required
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Your Message</label>
                <textarea
                  name="message"
                  className="w-full px-4 py-3 rounded-lg bg-gray-100 border border-gray-300 focus:outline-none focus:ring-2 text-black"
                  rows="5"
                  placeholder="Type your message..."
                  required
                ></textarea>
              </div>
            </div>
            <div className="text-center mt-6">
              <motion.button
                type="submit"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="inline-block bg-black text-white  px-6 py-3 rounded-full font-semibold shadow-md hover:bg-slate-900 transition"
              >
                Send Message
              </motion.button>
            </div>
          </motion.form>

          <motion.div
            key={`info-${animateKey}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="space-y-6"
          >
            <div className="bg-white p-6 rounded-xl shadow-md flex gap-4 items-start">
              <div className="text-black text-2xl">
                <IoMdMail />
              </div>
              <div>
                <h5 className="text-xl font-bebas">Email Address</h5>
                <a href="mailto:info@unitedom.net" className="text-gray-600 block">info@unitedom.net</a>
                <small className="text-gray-400">Response time: 24 hours</small>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md flex gap-4 items-start">
              <div className="text-black text-2xl">
                <FaPhoneAlt />
              </div>
              <div>
                <h5 className="text-xl font-bebas">Phone Number</h5>
                <a href="https://wa.me/96895566512" className="text-gray-600 block">+968 95566512</a>
                <small className="text-gray-400">Sat-Thu • 9 am - 6 pm GST</small>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
